<template>
  <div class="connection">
    <div class="back-img"></div>
    <div class="content">
      <div class="top">
        <div>
          <img alt="公司总部地址" class="mb-30" src="@image/map.png" />
          <p class="mb-10">总部地址</p>
          <p>武汉市武昌区武珞路帝斯曼国际中心25层</p>
        </div>
        <div>
          <img alt="400-800-7969" class="mb-30" src="@image/phone.png" />
          <p class="mb-10">联系电话</p>
          <p>400-800-7969</p>
        </div>
        <div>
          <img alt="电子邮箱" class="mb-30" src="@image/email.png" />
          <p class="mb-10">电子邮箱</p>
          <p>service@pinnongjt.com</p>
        </div>
      </div>
      <div class="border"></div>
      <div class="bottom">
        <div class="left-box">
          <h2 class="mb-30">在线留言</h2>
          <el-form
            :model="ruleForm"
            :rules="rules"
            class="demo-ruleForm"
            label-width="100px"
            ref="ruleForm"
          >
            <el-form-item required>
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-form-item prop="name">
                    <el-input
                      placeholder="姓名"
                      v-model="ruleForm.name"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item prop="phone">
                    <el-input
                      placeholder="电话"
                      v-model="ruleForm.phone"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item required>
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-form-item prop="province">
                    <el-input
                      placeholder="所在省份"
                      v-model="ruleForm.province"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item prop="city">
                    <el-input
                      placeholder="所在城市"
                      v-model="ruleForm.city"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item prop="content">
              <el-input
                placeholder="内容"
                type="textarea"
                v-model="ruleForm.content"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                @click="submitForm('ruleForm')"
                class="btn"
                type="primary"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="right">
          <baidu-map
            :center="map.center"
            :zoom="map.zoom"
            @ready="handler"
            class="map"
          >
            <!--缩放-->
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <!--定位-->
            <bm-geolocation
              :autoLocation="true"
              :showAddressBar="true"
              anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            ></bm-geolocation>
            <!--点-->
            <bm-marker
              :dragging="map.dragging"
              :position="map.center"
              animation="BMAP_ANIMATION_DROP"
            >
              <!--提示信息-->
              <bm-info-window :show="map.show">Hello~</bm-info-window>
            </bm-marker>
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Qs from 'qs'
import { addLeaveComment } from '@/api/current'
export default {
  name: 'connection',

  data() {
    return {
      ruleForm: {
        name: '',
        content: '',
        city: '',
        province: '',
        phone: ''
      },
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        content: [{ required: true, message: '必填', trigger: 'blur' }],
        phone: [{ required: true, message: '必填', trigger: 'blur' }]
      },

      map: {
        center: { lng: 121.447254, lat: 31.32362 },
        zoom: 15,
        show: true,
        dragging: true
      }
    }
  },
  methods: {
    //地图
    handler({ BMap, map }) {
      var point = new BMap.Point(114.336164, 30.541782)
      map.centerAndZoom(point, 16)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, {
        strokeColor: 'Red',
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: 'Red',
        fillColor: '#f03'
      })
      map.addOverlay(circle)
    },
    // 提交留言
    submitForm(formName) {
      let isPhone = /^1[3456789]\d{9}$/
      let phone = this.ruleForm.phone
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!isPhone.test(phone)) {
            return this.Message.warning('请正确输入手机号码')
          }

          addLeaveComment(this.ruleForm)
            .then(res => {
              if (res.code) {
                this.Message.success('留言成功')
                this.ruleForm = {}
              } else {
                this.Message.warning('留言失败')
              }
            })
            .catch(err => {
              console.log(err)
            })
          // this.$http
          //   .post('/addLeaveComment', Qs.stringify(this.ruleForm))
          //   .then(res => {
          //     if (res.data.code) {
          //       this.Message.success('留言成功')
          //       this.ruleForm = {}
          //     } else {
          //       this.Message.warning('留言失败')
          //     }
          //   })
        } else {
          this.Message.warning('请输入留言信息')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scope>
.connection {
  .back-img {
    width: 100%;
    background-image: url('../../assets/image/connection.png');
    margin-top: -62px;
  }
  .top {
    display: flex;
    justify-content: space-around;
    padding: 100px 250px;
    text-align: center;
    p {
      color: #666666;
      font-size: 16px;
    }
    .mb-10 {
      color: #303030;
      font-size: 18px;
    }
  }
  .border {
    width: 1000px;
    height: 1px;
    background: rgba(235, 235, 235, 1);
    margin: auto;
  }
  .bottom {
    display: flex;
    justify-content: space-around;
    padding: 50px 150px;
    .left-box {
      width: 600px;
      h2 {
        text-align: start;
        text-align: initial;
        font-size: 30px;
        font-weight: 400;
        color: rgba(35, 35, 35, 1);
      }
    }

    .right {
      .map {
        width: 770px;
        height: 430px;
      }
    }
    .el-form-item__content {
      text-align: start;
      text-align: initial;
      margin-left: 0 !important;
    }
    .el-textarea__inner {
      width: 92%;
    }
    .btn {
      padding: 12px 80px;
    }
  }
}
</style>
